/* eslint-disable array-callback-return */
/* eslint-disable linebreak-style */
import { Component, createElement } from 'react';
import * as prodLytics from './analytics/prod';
import * as devLytics from './analytics/dev';

function isLocal(host) {
  return window.location.hostname === host;
}

function isDev() {
  return process.env.NODE_ENV !== 'production';
}

function isExcluded(exclude) {
  const { pathname } = window.location;

  return exclude.some((item) => pathname.match(item));
}

const withATM = (adobeTagManager, Router, { localhost = 'localhost', exclude = [] } = {}) => (Page) => {
  class WithAdobeTagManager extends Component {
    constructor(props) {
      super(props);
      this.state = {
        atm: undefined
      };
    }

    componentDidMount() {
      if (!isExcluded(exclude)) {
        // check if it should track
        const shouldNotTrack = isLocal(localhost) || isDev();
        // check if it should use production or dev atm
        const atm = shouldNotTrack ? devLytics : prodLytics;

        // save possible previously defined callback
        const previousCallback = Router.onRouteChangeComplete;
        Router.onRouteChangeComplete = () => {
          setTimeout(() => {
            // log page
            atm.trackAsyncPV(adobeTagManager);
          }, 0);
          // call previously defined callback if is a function
          if (typeof previousCallback === 'function') {
            previousCallback();
          }
        };

        this.setState({
          atm
        });
      }
    }

    render() {
      return createElement(Page, {
        ...this.props,
        atm: this.state.atm
      });
    }
  }

  return WithAdobeTagManager;
};

export default withATM;
